import {
  SEND_REGISTER_EMAIL_OTP_REQUEST,
  SEND_REGISTER_EMAIL_OTP_SUCCESS,
  SEND_REGISTER_EMAIL_OTP_FAIL,
  VERIFY_REGISTER_EMAIL_OTP_REQUEST,
  VERIFY_REGISTER_EMAIL_OTP_SUCCESS,
  VERIFY_REGISTER_EMAIL_OTP_FAIL,
  LOAD_USER_REQUEST,
  LOAD_USER_SUCCESS,
  LOAD_USER_FAIL,
  CLEAR_ERRORS,
  LOGOUT_SUCCESS,
  LOGOUT_FAIL,
} from "../constant/userConstants";

export const userReducer = (state = { user: {} }, action) => {
  switch (action.type) {
    case VERIFY_REGISTER_EMAIL_OTP_REQUEST:
    case SEND_REGISTER_EMAIL_OTP_REQUEST:
    case LOAD_USER_REQUEST:
      return {
        loading: true,
        isAuthenticated: false,
      };

    case SEND_REGISTER_EMAIL_OTP_SUCCESS:
      return {
        ...state,
        loading: false,
        response: action.payload,
        isAuthenticated: false,
        success: true,
        error: false,
      };

    case VERIFY_REGISTER_EMAIL_OTP_SUCCESS:
      return {
        ...state,
        loading: false,
        response: action.payload,
        isAuthenticated: true,
        success: true,
        error: false,
      };

    case LOAD_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        response: action.payload,
        isAuthenticated: true,
        success: true,
        error: false,
      };

    case VERIFY_REGISTER_EMAIL_OTP_FAIL:
    case SEND_REGISTER_EMAIL_OTP_FAIL:
      return {
        ...state,
        loading: false,
        success: false,
        error: true,
        response: action.payload,
        isAuthenticated: false,
      };

    case LOAD_USER_FAIL:
      return {
        loading: false,
        isAuthenticated: false,
        response: action.payload,
        error: true,
      };

    case LOGOUT_SUCCESS:
      return {
        loading: false,
        error:false,
        response: action.payload,
        isAuthenticated: false,
      };

    case LOGOUT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};
